import React from "react";
import useConstrainable from "./use-constrainable";

export default function useFilterMeta(name, key, defaultValue = null) {

    const constrainable = useConstrainable();

    if (!constrainable) {
        throw new Error('Tried to get filter meta, but constrainable were not provided.');
    }

    function fetchValue() {
        return constrainable.getFilterMeta(name, key, defaultValue);
    }

    const [value, setValue] = React.useState(fetchValue());

    React.useEffect(() => {
        const nextValue = fetchValue();
        if(nextValue !== value) {
            setValue(nextValue);
        }
    }, [name, key, defaultValue]);

    return value;
}
